import lists from '../lists';

const listDefault = {
    ...lists,
} as const;

export default listDefault;
